import React, { useEffect, useRef } from 'react'
import styled from 'styled-components/macro'
import {
  SearchBar,
  SearchIcon,
  SearchInput,
  SearchInputContainer,
} from 'src/components/Reusable/Search/Search.styles'

const Wrapper = styled.div`
  padding: 8px 12px;

  ${SearchBar} {
    width: 100%;
  }
`

type DropdownSearchInputProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void
}

export const DropdownSearchInput = ({
  value,
  onChange,
  placeholder = 'Search',
  autoFocus,
  onClick,
}: DropdownSearchInputProps): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (autoFocus) inputRef.current?.focus()
  }, [autoFocus])

  return (
    <Wrapper>
      <SearchBar>
        <SearchInputContainer>
          <SearchIcon />
          <SearchInput
            ref={inputRef}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onClick={onClick}
            placeholder={placeholder}
          />
        </SearchInputContainer>
      </SearchBar>
    </Wrapper>
  )
}
